var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'underscore.string', 'backbone', 'core', 'app-common/template/categorization/categorization-notes.htm', 'app-common/component/baseView', 'app-common/component/loader', 'component/bookkeeper-notifications', 'common/lib/jquery.hotkeys', 'common/lib/md5'], function($, _, _s, Backbone, core, categorizationNotesTemplate, BaseView, loader, BookkeeperNotifications) {
  var CategorizationNotesView;
  return CategorizationNotesView = (function(_super) {

    __extends(CategorizationNotesView, _super);

    function CategorizationNotesView() {
      CategorizationNotesView.__super__.constructor.apply(this, arguments);
    }

    CategorizationNotesView.prototype.className = 'categorization-notes-container';

    CategorizationNotesView.prototype.events = {
      'click .comments-display__mark-as-read': 'removeBKNotificationEvents',
      'dropdownPicked .suggested-categories input': 'selectSuggestedCategories',
      'click .suggested-categories__reset': 'resetSuggestedCategories'
    };

    CategorizationNotesView.prototype.notifications = [];

    CategorizationNotesView.prototype.eventName = 'event.categorization.responded';

    CategorizationNotesView.prototype.initialize = function(documentModel) {
      this.documentModel = documentModel;
      this.transactionId = documentModel.get('id');
      this.userId = core.getCurrentClientId();
      return this.ledgerAccountsCollection = core.getCollection('ledgerAccounts');
    };

    CategorizationNotesView.prototype.removeBKNotificationEvents = function() {
      var $button, promise,
        _this = this;
      $button = this.$('.comments-display__mark-as-read');
      $button.velocity('transition.slideUpOut', {
        duration: 500
      });
      promise = this.bkNotifications.removeEvents(this.transactionId, this.eventName);
      promise.fail(function() {
        return _this.showNotification({
          type: 'error',
          text: 'Unable to remove categorization note notification.'
        }, $button.velocity('transition.slideDownIn', {
          duration: 100
        }));
      });
      return promise.done(function() {
        return $button.velocity('transition.slideUpOut', {
          duration: 100,
          complete: function() {
            return $button.remove();
          }
        });
      });
    };

    CategorizationNotesView.prototype.selectSuggestedCategories = function(e) {
      var $reset, $row, element, index, value;
      element = $(e.currentTarget).prev();
      value = element.val();
      $row = element.closest('.suggested-categories__row');
      $reset = $(e.currentTarget).next();
      index = $row.data('index');
      $reset.attr('data-ledger-id', value);
      $row.toggleClass('edited', value > 0);
      return this.updateSuggestedCategories(value, index);
    };

    CategorizationNotesView.prototype.resetSuggestedCategories = function(e) {
      var $reset, $row, $select, ledgerId, transactionId;
      $reset = $(e.currentTarget);
      $row = $reset.closest('.suggested-categories__row');
      $select = $row.find('input');
      transactionId = $reset.data('transaction-id');
      ledgerId = $reset.data('ledger-id');
      $select.val('');
      $row.removeClass('edited');
      return this.removeSuggestedCategories(transactionId, ledgerId);
    };

    CategorizationNotesView.prototype.updateSuggestedCategories = function(suggestedLedgerId, index) {
      var hasSuggestedCategory, suggestedLedger, suggestedLedgers;
      suggestedLedgers = this.getSuggestedLedgers();
      hasSuggestedCategory = _.findWhere(suggestedLedgers, {
        ledgerAccountId: suggestedLedgerId
      });
      if (hasSuggestedCategory || (suggestedLedgerId === '0')) {
        return;
      }
      suggestedLedger = {
        ledgerAccountId: suggestedLedgerId
      };
      if (index > -1) {
        suggestedLedgers[index] = suggestedLedger;
      } else {
        suggestedLedgers.push(suggestedLedger);
      }
      return this.saveSuggestedLedgers(suggestedLedgers);
    };

    CategorizationNotesView.prototype.removeSuggestedCategories = function(id, suggestedLedgerId) {
      var suggestedLedgers;
      suggestedLedgers = this.getSuggestedLedgers();
      suggestedLedgers = suggestedLedgers.filter(function(item) {
        return item.ledgerAccountId !== (suggestedLedgerId != null ? suggestedLedgerId.toString() : void 0);
      });
      return this.saveSuggestedLedgers(suggestedLedgers);
    };

    CategorizationNotesView.prototype.getSuggestedLedgers = function() {
      var _ref;
      return ((_ref = this.documentModel.get('categorization')) != null ? _ref.suggestedLedgers : void 0) || [];
    };

    CategorizationNotesView.prototype.getSelectedLedgerAccountId = function() {
      var _ref;
      return (_ref = this.documentModel.get('categorization')) != null ? _ref.selectedLedgerAccountId : void 0;
    };

    CategorizationNotesView.prototype.saveSuggestedLedgers = function(suggestedLedgers) {
      var categorization, promise,
        _this = this;
      if (suggestedLedgers == null) {
        suggestedLedgers = [];
      }
      categorization = this.getCategorization();
      categorization.suggestedLedgers = suggestedLedgers || [];
      this.documentModel.set('categorization', categorization);
      loader.init({
        inline: true
      });
      promise = this.documentModel.save();
      promise.always(function() {
        return loader.hide();
      });
      return promise.success(function() {
        var _ref;
        _this.documentModel.trigger('change', (_ref = _this.documentModel) != null ? _ref.toJSON() : void 0);
        return core.trackEvent("Transaction Updated", {
          updated_field: "categorization",
          batch_mode: false,
          count: 1
        });
      });
    };

    CategorizationNotesView.prototype.getCategorization = function() {
      return this.documentModel.get('categorization') || {};
    };

    CategorizationNotesView.prototype.hasNote = function() {
      var _ref;
      return ((_ref = this.getCategorization()) != null ? _ref.clientResponse : void 0) != null;
    };

    CategorizationNotesView.prototype.hasClientResponses = function() {
      var _ref, _ref1;
      return ((_ref = this.getCategorization()) != null ? (_ref1 = _ref.suggestedLedgers) != null ? _ref1.length : void 0 : void 0) != null;
    };

    CategorizationNotesView.prototype.isAwaitingCategorization = function() {
      var awaitingCategories, entries,
        _this = this;
      entries = this.documentModel.get('dataEntries') || [];
      awaitingCategories = entries.map(function(entry) {
        var _ref;
        return (_ref = _this.ledgerAccountsCollection.get(entry != null ? entry.ledgerAccountId : void 0)) != null ? _ref.isAwaitingCategory() : void 0;
      });
      return _.some(awaitingCategories);
    };

    CategorizationNotesView.prototype.showCategorization = function() {
      return _.some([this.isAwaitingCategorization(), this.hasClientResponses()]);
    };

    CategorizationNotesView.prototype.setData = function() {
      var promise,
        _this = this;
      this.notifications = [];
      this.categorization = this.getCategorization();
      this.bkNotifications = new BookkeeperNotifications(this.transactionId);
      promise = this.bkNotifications.getEvents(this.userId, [this.transactionId], [this.eventName]);
      promise.done(function(eventData) {
        var _ref, _ref1, _ref2;
        _this.notifications = eventData != null ? (_ref = eventData[0]) != null ? (_ref1 = _ref.events) != null ? _ref1.full : void 0 : void 0 : void 0;
        return ((_ref2 = _this.notifications) != null ? _ref2.length : void 0) && _this.render();
      });
      return this.render();
    };

    CategorizationNotesView.prototype.getSerializedSuggestedLedgers = function() {
      var serialized, suggestedLedgers,
        _this = this;
      suggestedLedgers = this.getSuggestedLedgers();
      serialized = Math.min(3, suggestedLedgers.length + 1);
      serialized = _.range(serialized);
      return serialized.map(function(index) {
        var suggestedLedger;
        suggestedLedger = suggestedLedgers[index];
        if (suggestedLedgers[index]) {
          return {
            id: suggestedLedger.ledgerAccountId,
            name: suggestedLedger.ledgerName
          };
        }
        return {
          id: 0
        };
      }).filter(function(ledger, index) {
        if (!ledger.id && _this.getSelectedLedgerAccountId()) {
          return false;
        }
        if (!ledger.id && _this.hasNote()) {
          return false;
        }
        return true;
      });
    };

    CategorizationNotesView.prototype.getSelectableLedgers = function() {
      return this.ledgerAccountsCollection.filter(function(account) {
        return account.isEditable();
      });
    };

    CategorizationNotesView.prototype.enableFlexselect = function(selectedLedgerAccountId) {
      var $suggestedLedgerSelect;
      if (selectedLedgerAccountId == null) {
        selectedLedgerAccountId = this.getSelectedLedgerAccountId();
      }
      $suggestedLedgerSelect = this.$el.find('.suggested-categories select');
      $suggestedLedgerSelect.each(function() {
        var $row, $select, defaultValue;
        $select = $(this);
        $row = $select.closest('.suggested-categories__row');
        defaultValue = $select.data('default-value');
        $select.val(defaultValue);
        return $row.toggleClass('edited', defaultValue > 0);
      });
      return this.suggestedFlexSelect = $suggestedLedgerSelect.flexselect({
        sortAlphabetically: true
      });
    };

    CategorizationNotesView.prototype.onRender = function() {
      this.delegateEvents();
      return this.enableFlexselect();
    };

    CategorizationNotesView.prototype.render = function(transactionId, categorization) {
      var html;
      if (transactionId == null) {
        transactionId = this.transactionId;
      }
      if (categorization == null) {
        categorization = this.categorization;
      }
      html = this.$el.html(_.template(categorizationNotesTemplate, {
        categorization: this.categorization,
        notifications: this.notifications,
        suggestedLedgers: this.getSerializedSuggestedLedgers(),
        selectableLedgers: this.getSelectableLedgers(),
        selectedLedgerAccountId: this.getSelectedLedgerAccountId(),
        transactionId: this.transactionId,
        hasNote: this.hasNote(),
        showCategorization: this.showCategorization()
      }));
      this.onRender();
      return html;
    };

    return CategorizationNotesView;

  })(BaseView);
});
